import React, { useState, useEffect } from 'react'
import {toast} from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useNavigate } from "react-router-dom";
import Sidebar from "../user/sidebar";
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  Paper,
  Container,
} from "@mui/material";

const PendingReceivedReqItem = () => {
  const navigate = useNavigate();
  const params = useParams()
  const token = useSelector((state)=>state.user.token)
  const [loading, setLoading] = useState(false);
  const [contract, setContract] = useState(null);

  useEffect(()=> {
    const url = `https://salama-api.onrender.com/transactions/${params.id}`;

    fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
      .then(response => {
        if (!response.ok) {
          // Check if the response contains a JSON error message from the server
          return response.json().then(errorData => {
            throw new Error(errorData.message || 'Network response was not ok');
          });
        }
        return response.json();
      })
      .then(data => {
        console.log('Confirmation response:', data);
        setLoading(false)
        setContract(data.data)
        toast.success(data.message)
      })
      .catch(error => {
        console.error('Error:', error);
        setLoading(false)
        toast.error(error.message)
      });


  },[params.id, token])

  const acceptTransaction = ()=>{
    setLoading(true)
    const url = `https://salama-api.onrender.com/transactions/${params.id}/confirm_transaction`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    })
      .then(response => {
        if (!response.ok) {
          // Check if the response contains a JSON error message from the server
          return response.json().then(errorData => {
            throw new Error(errorData.message || 'Network response was not ok');
          });
        }
        return response.json();
      })
      .then(data => {
        console.log('Confirmation response:', data);
        setLoading(false)
        toast.success(data.message)
        navigate('/user')
      })
      .catch(error => {
        console.error('Error:', error);
        setLoading(false)
        toast.error(error.message)
      });

  }

  return (

    <Container maxWidth="xl" style={{ display: "flex" }}>
    <Sidebar />
    <Paper
      elevation={3}
      style={{ flex: "1", padding: "2rem", minHeight: "calc(100vh - 150px)" }}
    >
      <Typography variant="h4" align="center" gutterBottom>
        Add a Contract
      </Typography>
      <form >
        <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
        <TextField
            fullWidth
            label="Product Details"
            name="product_name"
            value={contract?.product_name || ""}
            variant="outlined"
            required
            InputLabelProps={{
              shrink: true,
            }}
          />
          </Grid>
          <Grid item xs={12} sm={6}>
          <TextField
              fullWidth
              label={"product_price"} // Use optional chaining and provide a fallback
              name="product price"
              variant="outlined"
              value={contract?.product_price || ""}
              required
              InputProps={{
                readOnly: true,
              }}    
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
          <TextField
              fullWidth
              label={"seller_email"} // Use optional chaining and provide a fallback
              name="Seller Email"
              variant="outlined"
              value={contract?.buyer_email || ""}
              required
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
          <TextField
              fullWidth
              label={"buyer_email"} // Use optional chaining and provide a fallback
              name="Buyer Email"
              variant="outlined"
              value={contract?.seller_email || ""}
              required
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="payment_terms"
              name="payment_terms"
              type="text"
              variant="outlined"
              value={contract?.payment_terms}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="salama_pay_terms"
              name="salama_pay_terms"
              type="text"
              variant="outlined"
              value={contract?.salama_terms}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="governing_law"
              name="governing_law"
              type="text"
              variant="outlined"
              value={contract?.governing_law}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="dispute_resolution"
              name="dispute_resolution"
              type="text"
              variant="outlined"
              value={contract?.dispute_resolution}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="agreement"
              name="agreement"
              type="text"
              variant="outlined"
              value={contract?.agreement}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{
                shrink: true, // Ensure the label is always in the outline
              }}
              label="termination"
              name="termination"
              type="text"
              variant="outlined"
              value={contract?.termination}
              rows={3}
              // onChange={handleInputChange}
              required
            />
          </Grid>

        </Grid>
        <Box mt={3}>
        <Typography variant="body2" color="textSecondary">
          Please note that by accepting you agree to the terms of the contract.
        </Typography>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            onClick={acceptTransaction}
            disabled={loading}
          >
            {loading ? "loading ..." : "Accept transaction"}
          </Button>
        </Box>
      </form>
    </Paper>
    </Container>
  )
}

export default PendingReceivedReqItem